import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Aura from '@primeuix/themes/aura';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import '@/assets/styles.scss';
import './core/js/veeValidation';
import CurrencyFormat from '@/core/directive/currencyFormat';
import { Validation } from '@/core/directive/validation';
import EnterFocus from '@/core/directive/enterFocus';

const app = createApp(App);
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.app-dark'
        }
    }
});

app.use(ToastService);
app.use(ConfirmationService);

app.directive('currency', CurrencyFormat);
app.directive('validate', Validation);
app.directive('enter-focus', EnterFocus);

app.mount('#app');

window.addEventListener('storage', (event) => {
    if (event.key === 'activeBranchId') {
        window.location.reload();
    }
});
